import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private theme = new BehaviorSubject<string>('theme-neutro');
  currentTheme = this.theme.asObservable();

  constructor() { }

  changeTheme(themeName: string): void {
    this.theme.next(themeName);
  }
}
